import { render, staticRenderFns } from "./TeapScoreComponent.vue?vue&type=template&id=a4f9c63e&scoped=true&"
import script from "./TeapScoreComponent.vue?vue&type=script&lang=js&"
export * from "./TeapScoreComponent.vue?vue&type=script&lang=js&"
import style0 from "./TeapScoreComponent.vue?vue&type=style&index=0&id=a4f9c63e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f9c63e",
  null
  
)

export default component.exports